<template>
  <div>

    <pageTable ref="snTable"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/company/cardSn"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="add_time">
          <DatePicker v-model="searchData.add_time" type="datetimerange" placeholder="消费时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <Button type="primary" @click="exportSn">导出</Button>
      </template>

    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  export default {
    name: "cardSn",
    components:{pageTable},
    props:{
      cardId:{
        type:Number,
        default: 0
      }
    },
    data() {
      return {
        searchData: {
          card_id:this.cardId,
          add_time:''
        },
        tableColumn: [
          {title: 'ID',key: 'sn_id',align: "center"},
          {title: '发生数量',key: 'amount',align: "center"},
          {title: '消费前数量',key: 'before_amount',align: "center"},
          {title: '消费后数量',key: 'after_amount',align: "center"},
          {title: '时间',key: 'add_time',align: "center"},
          {title: 'IP',key: 'add_ip',align: "center"},
          {title: '备注',key: 'remark',align: "center"},
        ],
        tableData: [],

      }
    },
    methods: {
      async exportSn(){
        let res = await this.$commonFun.postProxy('admin/company/exportCardSn',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`消费记录.xlsx`)
        })
      }
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
